import { Button, Divider, Form, Input, message, Modal, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import DeleteIcon from "../../../../components/icons/DeleteIcon";
import { isValidURL } from "../../../../common/helpers";
import { AddBrandProduct, UpdateBrandProduct } from "../../../../API/endpoints/Brands";

interface Props {
    open: boolean;
    editData?: any;
    onCancel: () => void;
    onSuccess: (data: any) => void;
    brand: any
}
const AddEditProductModal = (props: Props) => {
    const { editData, open, onSuccess, brand } = props;
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const [categories, setCategories] = useState<any[]>([]);
    const [subCategories, setSubCategories] = useState<any[]>([]);

    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        if (brand?.brand_name) {
            form.setFieldValue("brand_name", brand?.brand_name)
        }

        setCategories(brand?.brand_categories || []);
    }, [brand])


    useEffect(() => {
        if (editData && Object.keys(editData).length > 0) {
            form.setFieldsValue({
                name: editData?.name,
                category: editData?.category,
                sub_category: editData?.sub_category,
                description: editData?.description,
                product_links: editData?.product_links?.map((l: string) => ({ link: l })) || [{ link: "" }]
            })
        } else {
            form.setFieldValue("product_links", [{ link: "" }])
        }
    }, [editData])


    const onSubmit = () => {
        form.validateFields().then((values: any) => {
            setSubmitLoading(true);
            const req = {
                brand_id: brand.id,
                name: values?.name,
                category: values?.category,
                sub_category: values?.sub_category,
                description: values?.description || undefined,
                product_links: values?.product_links?.length > 0 ? values?.product_links?.map((l: any) => l?.link) : undefined
            }
            if (editData && Object.keys(editData).length > 0) {
                UpdateBrandProduct(editData?.id, req).then((res: any) => {
                    onSuccess(res?.data)
                    onReset();
                    setSubmitLoading(false);
                }).catch((err) => {
                    console.error('err', err);
                    setSubmitLoading(false);
                })
            } else {
                AddBrandProduct(req).then((res: any) => {
                    onSuccess(res?.data)
                    onReset();
                    setSubmitLoading(false);
                }).catch((err) => {
                    console.error('err', err);
                    setSubmitLoading(false);
                })
            }
        })
    }

    const onCancel = () => {
        props?.onCancel();
        onReset()
    }

    const onReset = () => {
        form.resetFields(["name", "category", "sub_category", "description", "product_links"]);
        setSubCategories([]);
    }

    const onChangeCategory = (value: number) => {
        setSubCategories(categories.find((item: any) => item?.focus_category === value)?.sub_categories?.map((o: string) => ({ label: o, value: o })) || [])
        form.resetFields(["sub_category"]);
    }

    // const linksList = useMemo(() => {
    //     return productLinks?.map((link: string, index: number) => {
    //         return (
    //             <div key={index} className="flex w-full gap-x-[8px]">
    //                 <Form.Item
    //                     className="col-span-2 w-full"
    //                     name={`product_link_${index}`}
    //                     rules={[
    //                         {
    //                             required: true, message: "Enter product link"
    //                         },
    //                         {
    //                             pattern: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/,
    //                             message: 'Please enter a valid product link',
    //                         },
    //                     ]}
    //                 >
    //                     <Input
    //                         className="w-full"
    //                         type="text"
    //                         placeholder="https://"

    //                     />
    //                 </Form.Item>
    //                 <Button type="text" className="leading-[12px]" icon={<DeleteIcon />} onClick={() => onDeleteLink(index)} />
    //             </div>
    //         )
    //     })
    // }, [productLinks])

    return (
        <Modal
            width={500}
            open={open}
            onCancel={() => onCancel()}
            classNames={{
                content: "!p-0 h-[calc(100vh-40px)] flex flex-col",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0 bg-white",
                body: "!px-[20px] !py-[12px] bg-[#F9FAFB] flex-1 overflow-auto",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            className="h-[calc(100% - 40px)] top-[20px] right-[20px] absolute pb-0"
            title={(
                <p className="m-0 font-[500] text-[14px]">
                    {editData && Object.keys(editData).length > 0 ? "Edit" : "Add New"} Product
                </p>
            )}
            okText={"Save"}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
            okButtonProps={{
                loading: submitLoading
            }}
            onOk={() => onSubmit()}
        >
            <Form layout="vertical" requiredMark={false} form={form}>
                {contextHolder}
                <div className="grid grid-cols-2 gap-[16px]">
                    <Form.Item
                        name="name"
                        label="Product Name"
                        rules={[{ required: true }]}
                    >
                        <Input
                            type="text"
                            placeholder="Product Name"
                        />
                    </Form.Item>
                    <Form.Item
                        name="brand_name"
                        label="Brand Name"
                        rules={[{ required: true }]}
                    >
                        <Input
                            type="text"
                            placeholder="Brand Name"
                            disabled
                        />
                    </Form.Item>
                    <Form.Item
                        name="category"
                        label="Category"
                        rules={[{ required: true }]}
                    >

                        <Select
                            placeholder="Select category"
                            options={categories}
                            fieldNames={{ label: "focus_category", value: "focus_category" }}
                            onChange={(value) => onChangeCategory(value)}
                        />
                    </Form.Item>
                    <Form.Item
                        name="sub_category"
                        label="Sub Category"
                        rules={[{ required: true }]}
                    >
                        <Select
                            placeholder="Select sub category"
                            options={subCategories}
                        />
                    </Form.Item>
                    <Form.Item
                        className="col-span-2"
                        name="description"
                        label="Description"
                    >
                        <Input.TextArea
                            placeholder="Description"
                        />
                    </Form.Item>
                    <Divider className="col-span-2 !my-[0]" />
                    <div className="col-span-2 flex flex-col gap-y-[8px] items-start w-full">
                        <label className="text-[12px]" title="Product Link">Product Link</label>
                        <Form.List name="product_links">
                            {(fields, { add, remove }) => (
                                <div className="flex flex-col gap-y-[8px] w-full">
                                    {fields.map((field) => (
                                        <div className="flex w-full gap-x-[8px]" key={field.key}>
                                            <Form.Item
                                                className="col-span-2 w-full"
                                                name={[field.name, 'link']}
                                                key={field.key} // Optional in newer versions
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Enter product link",
                                                    },
                                                    {
                                                        pattern: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/,
                                                        message: 'Please enter a valid product link',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    className="w-full"
                                                    type="text"
                                                    placeholder="https://"
                                                />
                                            </Form.Item>
                                            <Button
                                                type="text"
                                                className="leading-[12px]"
                                                icon={<DeleteIcon />}
                                                onClick={() => remove(field.name)}
                                            />
                                        </div>
                                    ))}
                                    <Button
                                        size="small"
                                        type="default"
                                        className="bg-white h-[26px] self-start"
                                        onClick={() => add()}
                                    >
                                        Add New
                                    </Button>
                                </div>
                            )}
                        </Form.List>

                        {/* {linksList} */}
                        {/* <Button size="small" type="default" className="bg-white h-[26px]" onClick={() => onAddLink()}>Add New</Button> */}
                    </div>

                </div>
            </Form>

        </Modal>
    )
}

export default AddEditProductModal